module.exports = __webpack_public_path__ + "img/ebooks-unactive.16d4856.svg";